import { useMutation } from '@apollo/react-hooks'
import DocumentsQuery from '../../queries/DocumentsQuery'
import Regenerate1919 from '../../mutations/Regenerate1919sMutation'
import { useSnackbar } from '../../contexts/SnackbarContext'
import { DocumentStatusOption } from '../constants'

const isDocumentTypeBusiness1919 = (documentType) =>
  documentType.startsWith('Document::T1919Business')

function useRegenerate1919({ loanId, document }) {
  const { setSuccessMessage, setErrorMessage } = useSnackbar()

  const [regenerate1919Mutation, { loading: regenerating }] = useMutation(
    Regenerate1919,
    {
      variables: {
        input: {
          loanId,
        },
      },
      onCompleted: () => setSuccessMessage('Document regenerated'),
      onError: () =>
        setErrorMessage('There was an error regenerating the document'),
      refetchQueries: [{ query: DocumentsQuery, variables: { rid: loanId } }],
      awaitRefetchQueries: true,
    }
  )

  const preventRegeneration =
    document.status === DocumentStatusOption.approve_and_commit

  const handleRegenerate = () =>
    !preventRegeneration && !regenerating && regenerate1919Mutation()

  return {
    showRegenerateOption: isDocumentTypeBusiness1919(document.type),
    regenerating,
    preventRegeneration,
    handleRegenerate,
  }
}
export default useRegenerate1919
